module.exports = __webpack_public_path__ + "img/1.1a49950c.png";